export default __webpack_public_path__ + "static/media/admin.af9ed04c.svg";